var React = require('react');

function ButtonBlackRightArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.00003 7.99998C8.00003 8.58332 7.77503 9.16665 7.33337 9.60832L1.90003 15.0417C1.65837 15.2833 1.25837 15.2833 1.0167 15.0417C0.775033 14.8 0.775033 14.4 1.0167 14.1583L6.45003 8.72498C6.85003 8.32498 6.85003 7.67498 6.45003 7.27498L1.0167 1.84165C0.775033 1.59998 0.775033 1.19998 1.0167 0.958315C1.25837 0.716648 1.65837 0.716648 1.90003 0.958315L7.33337 6.39165C7.77503 6.83332 8.00003 7.41665 8.00003 7.99998Z","fill":"#36373A"}));
}

ButtonBlackRightArrow.defaultProps = {"width":"8","height":"16","viewBox":"0 0 8 16","fill":"none"};

module.exports = ButtonBlackRightArrow;

ButtonBlackRightArrow.default = ButtonBlackRightArrow;
